import { Select, InputLabel } from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import {
  SectionContainer,
  SectionTitle,
  FilterFormControl,
  StyledMenuItem,
  FiltersGrid,
  TeamGrid,
  TeamMemberGrid,
  SkeletonCard,
  SkeletonImage,
  SkeletonInfoWrapper,
  SkeletonName,
  SkeletonTitle,
  SkeletonInfo,
  SkeletonLink,
  FiltersGridContainer,
} from '../styles';

const TeamSectionSkeleton = ({ filtersConfig }) => (
  <SectionContainer>
    <SectionTitle>Meet Our Practitioners</SectionTitle>

    <FiltersGridContainer container spacing={1.5} justifyContent="space-between">
      {filtersConfig.map((filter) => (
        <FiltersGrid item key={filter.key}>
          <FilterFormControl size="small" variant="outlined" disabled>
            <InputLabel id={`${filter.key}-label`}>{filter.label}</InputLabel>
            <Select
              labelId={`${filter.key}-label`}
              value=""
              IconComponent={KeyboardArrowDownRoundedIcon}
            >
              <StyledMenuItem value="">Loading...</StyledMenuItem>
            </Select>
          </FilterFormControl>
        </FiltersGrid>
      ))}
    </FiltersGridContainer>

    <TeamGrid container>
      {[...Array(6)].map((_, index) => (
        <TeamMemberGrid item xs="auto" key={index}>
          <SkeletonCard>
            <SkeletonImage variant="rectangular" animation="wave" />
            <SkeletonInfoWrapper>
              <SkeletonName variant="text" animation="wave" />
              <SkeletonTitle variant="text" animation="wave" />
              <SkeletonInfo variant="text" animation="wave" />
              <SkeletonInfo variant="text" animation="wave" />
              <SkeletonLink variant="text" animation="wave" />
            </SkeletonInfoWrapper>
          </SkeletonCard>
        </TeamMemberGrid>
      ))}
    </TeamGrid>
  </SectionContainer>
);

export default TeamSectionSkeleton;
